export default __webpack_public_path__ + "static/media/LK.6df19714.svg";